/// <summary>
/// The BACKSPACE keycode
/// </summary>
export const BACKSPACE = 8;

/// <summary>
/// The TAB keycode
/// </summary>
export const TAB = 9;

/// <summary>
/// The ENTER keycode
/// </summary>
export const ENTER = 13;

/// <summary>
/// The SHIFT keycode
/// </summary>
export const SHIFT = 16;

/// <summary>
/// The CTRL keycode
/// </summary>
export const CTRL = 17;

/// <summary>
/// The ALT keycode
/// </summary>
export const ALT = 18;

/// <summary>
/// The ESC keycode
/// </summary>
export const ESC = 27;

/// <summary>
/// The SPACE keycode
/// </summary>
export const SPACE = 32;

/// <summary>
/// The PAGEUP keycode
/// </summary>
export const PAGEUP = 33;

/// <summary>
/// The PAGEDOWN keycode
/// </summary>
export const PAGEDOWN = 34;

/// <summary>
/// The END keycode
/// </summary>
export const END = 35;

/// <summary>
/// The HOME keycode
/// </summary>
export const HOME = 36;

/// <summary>
/// The ABSOLUTELEFTARROW keycode
/// </summary>
/// <remarks>It is always be the left arrow keycode regardless of whether it is in the RTL mode or not.</remarks>
export const ABSOLUTELEFTARROW = 37;

/// <summary>
/// The UPARROW keycode
/// </summary>
export const UPARROW = 38;

/// <summary>
/// The ABSOLUTERIGHTARROW keycode
/// </summary>
/// <remarks>It is always be the right arrow keycode regardless of whether it is in the RTL mode or not.</remarks>
export const ABSOLUTERIGHTARROW = 39;

/// <summary>
/// The DOWNARROW keycode
/// </summary>
export const DOWNARROW = 40;

/// <summary>
/// The INSERT keycode
/// </summary>
export const INSERT = 45;

/// <summary>
/// The DELETE keycode
/// </summary>
export const DELETE = 46;

/// <summary>
/// The D0 keycode
/// </summary>
export const D0 = 48;

/// <summary>
/// The '@' keycode
/// </summary>
export const AT = 50;

/// <summary>
/// The '#' keycode
/// </summary>
export const HASH = 51;

/// <summary>
/// The D9 keycode
/// </summary>
export const D9 = 57;

/// <summary>
/// The SEMICOLONFF keycode
/// </summary>
export const SEMICOLONFF = 59;

/// <summary>
/// The KeyA keycode
/// </summary>
export const KeyA = 65;

/// <summary>
/// The KeyC keycode
/// </summary>
export const KeyC = 67;

/// <summary>
/// The KeyK keycode
/// </summary>
export const KeyK = 75;

/// <summary>
/// The KeyN keycode
/// </summary>
export const KeyN = 78;

/// <summary>
/// The KeyV keycode
/// </summary>
export const KeyV = 86;

/// <summary>
/// The KeyX keycode
/// </summary>
export const KeyX = 88;

/// <summary>
/// The KeyZ keycode
/// </summary>
export const KeyZ = 90;

/// <summary>
/// The NUMPAD0 keycode
/// </summary>
export const NUMPAD0 = 96;

/// <summary>
/// The NUMPAD9 keycode
/// </summary>
export const NUMPAD9 = 105;

/// <summary>
/// The F2 keycode
/// </summary>
export const F2 = 113;

/// <summary>
/// The F6 keycode
/// </summary>
export const F6 = 117;

/// The F9 keycode
/// </summary>
export const F9 = 120;

/// <summary>
/// The F10 keycode
/// </summary>
export const F10 = 121;

/// <summary>
/// The SEMICOLON keycode
/// </summary>
export const SEMICOLON = 186;

/// <summary>
/// The COMMA keycode
/// </summary>
export const COMMA = 188;

/// <summary>
/// The DOT keycode
/// </summary>
export const DOT = 190;

/// <summary>
/// The TILDE keycode
/// </summary>
export const TILDE = 192;

/// <summary>
/// The OPENBRACKET keycode
/// </summary>
export const OPENBRACKET = 219;

/// <summary>
/// The CLOSEBRACKET keycode
/// </summary>
export const CLOSEBRACKET = 221;

/// <summary>
/// The FORWARDSLASH keycode
/// </summary>
export const FORWARDSLASH = 191;

/// <summary>
/// The BACKSLASH keycode
/// </summary>
export const BACKSLASH = 220;

/// <summary>
/// The APOSTROPHE keycode
/// </summary>
export const APOSTROPHE = 222;
